import { useParams } from "react-router-dom"

export  function useRouteParam(name) {
  const params = useParams()
  return params[name]
}